export default __webpack_public_path__ + "static/media/Itel.041b0098.svg";